import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Avatar, SpinnerLoader } from 'shared/ui'
import { type IContactAll } from 'entities/Contacts'
import styles from 'widgets/SearchDropdown/ui/SelectedElement/ContactsElement/styles.module.scss'

type IWidgetContactsTriggerProps = {
  loading: boolean
  selectedItems: IContactAll[]
}

export const WidgetContactsTrigger: FC<IWidgetContactsTriggerProps> = observer(
  ({ selectedItems, loading }) => {
    const selectedItemsCount = selectedItems.length

    if (loading) return <SpinnerLoader ariaLabel={'WidgetContactsTrigger'} size={16} />
    if (!selectedItemsCount) return <>select</>

    const labelCount = () => {
      if (selectedItemsCount === 1) {
        const item = selectedItems[0]

        return item.name
      }

      return `${selectedItemsCount} contacts`
    }

    return (
      <div className={styles.container}>
        <div className={styles.avatars}>
          {selectedItems.slice(0, 3).map((item, idx) => (
            <div
              className={styles.avatar}
              key={item.id}
              style={{ marginLeft: idx > 0 ? '-9px' : 0, zIndex: idx }}
            >
              <Avatar size={16} fontSize={10} info={item.avatarInfo} />
            </div>
          ))}
        </div>
        <span className={styles.selectedLabel}>{labelCount()}</span>
      </div>
    )
  }
)
